module.exports = __webpack_public_path__ + "static/img/DM_H5.49655ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DM_H5.png
// module id = nzNq
// module chunks = 34